import React from "react";
import {
  BrowserRouter as Router,
  HashRouter,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Dashboard from "./dashboard/Dashboard";
import SubmitArticle from "./submitArticle";
import ArticleList from "./articleList";
import Chats from "./chats";
import PaymentChat from "./paymentChat";
import SideBar from "./clientComponents/SideBar";
import Header from "./clientComponents/Header";
import NotFound from "../../commonComponents/Notfound";
import SingleArticle from "./SingleArticle";
import Adjustment from "./adjustment";

const ClientRoutes = () => {
  return (
    <div className="main_components d-flex">
      <SideBar />
      <div className="rightPanel">
        <Header />
        <Routes>
          <Route path={`/`} element={<Navigate to="/client/dashboard" />} />

          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/" element={<Dashboard />} />
          <Route path="/submit-article" element={<SubmitArticle />} />
          <Route path="/submit-adjustment" element={<Adjustment />} />

          <Route path="/article/:id" element={<SingleArticle />} />
          <Route path="/Articles" element={<ArticleList />} />
          <Route path="/chat" element={<Chats />} />
          <Route path="/payment-chat" element={<PaymentChat />} />
          <Route path={`/*`} element={<NotFound />} />
        </Routes>
      </div>
    </div>
  );
};

export default ClientRoutes;
